import type { InjectionKey } from 'virtual-vue';
import type { FormContext, FormItemContext } from './types';

export const FORM_KEY: InjectionKey<FormContext> = Symbol('form');
export const FORM_ITEM_KEY: InjectionKey<FormItemContext> = Symbol('formItem');
